import { render, staticRenderFns } from "./BdoSelect.vue?vue&type=template&id=e94429dc&scoped=true"
import script from "./BdoSelect.vue?vue&type=script&lang=js"
export * from "./BdoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e94429dc",
  null
  
)

export default component.exports